import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { appLogEvent } from '.';
import { useAppSelector } from '../../storeHook';
import { setScreenUrlToLoacalStorage } from '../constants/route';

type TIME_SPENT_SEGMENT_TEXT =
  | 'LESS_THAN_1_MINUTE'
  | 'MORE_THAN_1_MINUTE'
  | 'MORE_THAN_2_MINUTES'
  | 'MORE_THAN_5_MINUTES'
  | 'MORE_THAN_15_MINUTES'
  | 'MORE_THAN_30_MINUTES'
  | 'MORE_THAN_1_HOUR';

const getTimeSpentSegment = (
  timeSpentInMinutes: number
) => {
  const timeSegment: TIME_SPENT_SEGMENT_TEXT =
    timeSpentInMinutes > 60
      ? 'MORE_THAN_1_HOUR'
      : timeSpentInMinutes > 30
      ? 'MORE_THAN_30_MINUTES'
      : timeSpentInMinutes > 15
      ? 'MORE_THAN_15_MINUTES'
      : timeSpentInMinutes > 5
      ? 'MORE_THAN_5_MINUTES'
      : timeSpentInMinutes > 2
      ? 'MORE_THAN_2_MINUTES'
      : timeSpentInMinutes > 1
      ? 'MORE_THAN_1_MINUTE'
      : 'LESS_THAN_1_MINUTE';
  return timeSegment;
};

const useFirebaseScreenTracking = () => {
  const location = useLocation();
  const user_name = useAppSelector(
    (state) => state.authUser?.userName
  );

  useEffect(() => {
    const windowLocation = window.location;
    const screen_url = windowLocation.href.replace(
      windowLocation.origin,
      ''
    );
    setScreenUrlToLoacalStorage(screen_url);
    const enterTime = new Date();
    return () => {
      const exitTime = new Date();
      const time_spent_in_minutes =
        (exitTime.getTime() - enterTime!.getTime()) /
        (1000 * 60);

      if (user_name) {
        appLogEvent('screen_view', {
          screen: screen_url,
          user_name,
          time_spent_in_minutes:
            time_spent_in_minutes.toFixed(2),
          time_spent_segment: getTimeSpentSegment(
            time_spent_in_minutes
          ),
        });
      }
    };
  }, [location, user_name]);
};

export default useFirebaseScreenTracking;
